// extracted by mini-css-extract-plugin
module.exports = {"topbar":"topbar-module--topbar--1UVKn","fixed":"topbar-module--fixed--3tlqd"};